/* eslint-disable no-console */
import React, { Component } from 'react';
import { formatRoute } from 'react-router-named-routes';
// adopt
import { adopt } from 'react-adopt';
// graphQL
import gql from 'graphql-tag';
// our components
import { EXCHANGE_RATE } from 'routes/paths';
import RouterContext from 'helpers/routerContext';
import { Mutation } from 'components/common/Query';
import ExchangeRateForm from 'components/ExchangeRate/Form';

/**
 * Mutation to create an exchange rate
 */
export const CREATE_EXCHANGE_RATE_MUTATION = gql`
  mutation(
    $currencyFrom: CreateExchangeRateFormCurrencyFrom!
    $currencyTo: CreateExchangeRateFormCurrencyTo!
    $rate: Float!
    $startDate: Date!
    $endDate: Date!
  ) {
    createExchangeRate(
      input: {
        currencyFrom: $currencyFrom
        currencyTo: $currencyTo
        rate: $rate
        startDate: $startDate
        endDate: $endDate
      }
    ) {
      exchangeRate {
        id
        __typename
      }
      errors {
        field
        messages
        __typename
      }
      clientMutationId
      __typename
    }
  }
`;

/**
 * @class
 * @extends Component
 */
class ExchangeRateCreateContainer extends Component {
  static contextType = RouterContext;

  constructor(props) {
    super(props);
    this.state = {
      errors: [],
    };
    this.Compose = adopt({
      mutateExchangeRateCreate: this.exchangeRateCreate,
    });
  }

  /**
   * @description
   * Mutation callback to compose with list query.
   *
   * @param {*} render - Mutation's render props.
   * @returns {*} Mutation component.
   */
  exchangeRateCreate = ({ render }) => (
    <Mutation
      mutation={CREATE_EXCHANGE_RATE_MUTATION}
      onCompleted={this.exchangeRateCreateCompleted}
    >
      {handleExchangeRateCreate => render({ handleExchangeRateCreate })}
    </Mutation>
  );

  /**
   * @description
   * Mutation callback when create exchange rate is completed.
   *
   * @param {Object} createAd - Mutation result.
   */
  exchangeRateCreateCompleted = async ({ createExchangeRate }) => {
    const history = this.context;
    const { errors, exchangeRate } = createExchangeRate;
    if (!errors) {
      history.push(formatRoute(EXCHANGE_RATE.DETAILS, { id: exchangeRate.id }));
    } else {
      this.setState({ errors });
    }
  };

  /**
   * @description
   * Close notification.
   * @returns {undefined} - No returns value.
   */
  handleCloseNotification = () => {
    this.setState({ errors: [] });
  };

  /**
   * @description
   * Render ExchangeRateForm component.
   *
   * @returns {*} Component to render.
   */
  render() {
    const { errors } = this.state;
    return (
      <this.Compose>
        {({ mutateExchangeRateCreate: { handleExchangeRateCreate } }) => (
          <ExchangeRateForm
            exchangeRateSave={exchangeRate =>
              handleExchangeRateCreate({ variables: exchangeRate })
            }
            errors={errors}
            closeNotification={this.handleCloseNotification}
          />
        )}
      </this.Compose>
    );
  }
}

export default ExchangeRateCreateContainer;
